import React, { ChangeEvent } from "react";
import ReactModal from "react-modal";
import { RouteComponentProps } from "react-router";
import { DateTime } from "luxon";

import withTitle from "../withTitle";
import { V1, V2 } from "../../Api";
import { QuestionnaireViewInner } from "./QuestionnaireView";
import { Link } from "react-router-dom";
import HasRight from "../HasRight";
import { IAuthProps, WellKnownGroups } from "../AuthContext";
import withAuth from "../withAuth";
import withProps from "../withProps";
import { formatName, formatPhone, parseDateSafe } from "../../Utilities";
import NoteBox from "../NoteBox";
import ViewToolbar from "../ViewToolbar";
import ToolbarMenuItem from "../ToolbarMenuItem";

import "../../modal.css";

interface IOutreachContactDetailsViewState {
    isLoading: boolean | string;
    isContactDialogOpen: boolean;
    isNotNeededDialogOpen: boolean;
    isEditDialogDialogOpen: boolean;
    isTextDialogOpen: boolean;
    isDialogLoading: boolean | string;
    canUseMessaging: boolean
    survey: any;

    messagingNumber: any;
    messageTemplates: any[];

    contactStatus: string;
    contactStartDate: string;
    contactStartTime: string;
    contactEndDate: string;
    contactEndTime: string;
    contactNote: string;
    contactFiles: string[];

    messageType: string;
    messageBody: string;
    messageBodyOriginal: string;

    editNameFirst: string;
    editNameLast: string;
    editBirthdate: string;
    editPhone: string;
    editInsurance: string;
}

interface IOutreachContactDetailsViewProps extends RouteComponentProps<any>, IAuthProps {
    group: string;
}

class OutreachContactDetailsView extends React.Component<IOutreachContactDetailsViewProps, IOutreachContactDetailsViewState> {
    private contactNoteRef: React.RefObject<NoteBox> = React.createRef();

    constructor(props: Readonly<IOutreachContactDetailsViewProps>) {
        super(props);

        const state: IOutreachContactDetailsViewState = {
            isLoading: true,
            isContactDialogOpen: false,
            isNotNeededDialogOpen: false,
            isEditDialogDialogOpen: false,
            isTextDialogOpen: false,
            isDialogLoading: false,
            canUseMessaging: props.authContext.hasRight("msg:read") && props.authContext.hasRight("msg:send"),

            messagingNumber: {},
            messageTemplates: [],

            survey: {},

            contactStatus: "",

            contactStartDate: "",
            contactStartTime: "",
            contactEndDate: "",
            contactEndTime: "",
            contactNote: "",
            contactFiles: [],

            messageType: "",
            messageBody: "",
            messageBodyOriginal: "",

            editNameFirst: "",
            editNameLast: "",
            editBirthdate: "",
            editPhone: "",
            editInsurance: "",
        };

        this.state = state;

        this.handleContactNote = this.handleContactNote.bind(this);
        this.handleContactNoteDialog = this.handleContactNoteDialog.bind(this);
        this.handleContactNoteChange = this.handleContactNoteChange.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleNotNeeded = this.handleNotNeeded.bind(this);
        this.openContactDialog = this.openContactDialog.bind(this);
        this.closeContactDialog = this.closeContactDialog.bind(this);
        this.submitContactDialog = this.submitContactDialog.bind(this);
        this.openNotNeededDialog = this.openNotNeededDialog.bind(this);
        this.closeNotNeededDialog = this.closeNotNeededDialog.bind(this);
        this.toggleEditDialog = this.toggleEditDialog.bind(this);
        this.submitEditDialog = this.submitEditDialog.bind(this);
        this.openTextDialog = this.openTextDialog.bind(this);
        this.closeTextDialog = this.closeTextDialog.bind(this);
        this.submitTextDialog = this.submitTextDialog.bind(this);
    }

    public componentDidMount() {
        if (this.state.canUseMessaging) {
            this.loadMessagingInfo();
        }

        this.loadSurvey();
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="viewer-root">
                <div className="spinner spinner-center lds-dual-ring-big" />
            </div>;
        }

        if (typeof this.state.isLoading === "string") {
            return <div className="viewer-root">
                <div className="error-text">{this.state.isLoading}</div>
            </div>;
        }

        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <ToolbarMenuItem right="survey:write">
                        <button type="button" className="icon-pencil" title="Update info..." onClick={this.toggleEditDialog} />
                    </ToolbarMenuItem>
                </ViewToolbar>
                {this.state.isContactDialogOpen
                    ? <ReactModal isOpen={this.state.isContactDialogOpen} onRequestClose={this.closeContactDialog}
                        overlayClassName="modal-overlay" className="modal-content modal-larger" portalClassName="modal-portal"
                        bodyOpenClassName="modal-open" contentLabel="Contact dialog">
                        <form className="input-form">
                            <section className="info-block">
                                <header>
                                    <h3>Contacted</h3>
                                </header>

                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="contact-result">Contact result</label>
                                        <select id="contact-result" name="contactStatus" value={this.state.contactStatus} onChange={this.handleInputChanged}>
                                            <option value="">Select an option...</option>
                                            <option value="reachedmakeappointment">Reached patient, schedule an appointment</option>
                                            <option value="reacheddidntwant">Reached patient, did not want anything</option>
                                            <option value="calllater">Reached patient, contact again later</option>
                                            <option value="donotcontact">Do not contact again</option>
                                        </select>
                                    </div>
                                </section>
                            &nbsp;
                            <section>
                                    <div className="input-form-group">
                                        <label>Note {!this.props.authContext.hasRight("oreach:c:note:opt") ? <small>(required)</small> : <small>(optional)</small>}</label>
                                        <NoteBox ref={this.contactNoteRef} defaultNoteOpen={true} allowUpload={true} requireUpload={false} uploadCompress="image" hideLoading={true} stayOpenAfterSubmit={true} mode="single" onNewNote={this.handleContactNoteDialog} onNewNoteChange={this.handleContactNoteChange} />
                                    </div>
                                </section>
                                {this.renderContactDialogInnerBody()}
                                {
                                    this.state.isDialogLoading === true
                                        ? <div className="spinner lds-dual-ring" />
                                        : typeof this.state.isDialogLoading === "string"
                                            ? <div className="error-text"><br />{this.state.isDialogLoading}</div>
                                            : null
                                }
                            &nbsp;
                            <div className="action-panel-dialog">
                                    <span className="spring" />
                                    <button type="button" className="button green" onClick={this.submitContactDialog} disabled={this.isContactDialogButtonDisabled()}>Submit</button>
                                    <button type="button" className="button" onClick={this.closeContactDialog}>Close</button>
                                </div>
                            </section>
                        </form>
                    </ReactModal>
                    : null}
                {this.state.isNotNeededDialogOpen
                    ? this.renderNotNeededDialog()
                    : null}
                {this.state.isEditDialogDialogOpen
                    ? <ReactModal isOpen={this.state.isEditDialogDialogOpen} onRequestClose={this.toggleEditDialog}
                        overlayClassName="modal-overlay" className="modal-content modal-content-600" portalClassName="modal-portal"
                        bodyOpenClassName="modal-open" contentLabel="Edit information">
                        <form className="input-form">
                            <section className="info-block">
                                <header>
                                    <h3>Update/Correct information</h3>
                                </header>
                                <p>
                                    You can update and correct some of the information for this patient if it is no longer accurate.
                            </p>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-name-first">First Name</label>
                                        <input type="text" id="frm-name-first" name="editNameFirst" value={this.state.editNameFirst} onChange={this.handleInputChanged} autoComplete="off" />
                                    </div>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-name-last">Last Name</label>
                                        <input type="text" id="frm-name-last" name="editNameLast" value={this.state.editNameLast} onChange={this.handleInputChanged} autoComplete="off" />
                                    </div>
                                </section>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-dob">Birthdate</label>
                                        <input type="date" id="frm-dob" name="editBirthdate" value={this.state.editBirthdate} onChange={this.handleInputChanged} autoComplete="off" />
                                    </div>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-phone">Phone Number</label>
                                        <input type="tel" id="frm-phone" name="editPhone" value={this.state.editPhone} onChange={this.handleInputChanged} autoComplete="off" />
                                    </div>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-insurance">Insurance</label>
                                        <input type="text" id="frm-insurance" name="editInsurance" value={this.state.editInsurance} onChange={this.handleInputChanged} />
                                    </div>
                                </section>
                                {
                                    this.state.isDialogLoading === true
                                        ? <div className="spinner lds-dual-ring" />
                                        : typeof this.state.isDialogLoading === "string"
                                            ? <div className="error-text"><br />{this.state.isDialogLoading}</div>
                                            : null
                                }
                            &nbsp;
                            <div className="action-panel-dialog">
                                    <span className="spring" />
                                    <button type="button" className="button green" onClick={this.submitEditDialog}>Save</button>
                                    <button type="button" className="button" onClick={this.toggleEditDialog}>Close</button>
                                </div>
                            </section>
                        </form>
                    </ReactModal>
                    : null}
                {this.state.isTextDialogOpen
                    ? <ReactModal isOpen={this.state.isTextDialogOpen} onRequestClose={this.closeTextDialog}
                        overlayClassName="modal-overlay" className="modal-content modal-content-600" portalClassName="modal-portal"
                        bodyOpenClassName="modal-open" contentLabel="Text message dialog">
                        <form className="input-form">
                            <section className="info-block">
                                <header>
                                    <h3>Send text message &mdash; Using {formatPhone(this.state.messagingNumber.number)}</h3>
                                </header>
                                <p>
                                    This is intended <b className="red"><em>ONLY</em></b> for sending another text after updating the phone number.
                                </p>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="message-type">Message</label>
                                        <select id="message-type" name="messageType" value={this.state.messageType} onChange={this.handleTextMessageType}>
                                            <option value="">Select a message template...</option>
                                            {this.state.messageTemplates.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                                            <option value="custom">Custom message</option>
                                        </select>
                                    </div>
                                </section>
                                {this.state.isDialogLoading && !this.state.messageBody
                                    ? null
                                    : <section>
                                        <div className="input-form-group">
                                            <label htmlFor="message-sample">Message body</label>
                                            <textarea id="message-sample" className="input-textarea-medium" name="messageBody" value={this.state.messageBody} onChange={this.handleInputChanged} />
                                        </div>
                                    </section>
                                }
                                {
                                    this.state.isDialogLoading === true
                                        ? <div className="spinner lds-dual-ring" />
                                        : typeof this.state.isDialogLoading === "string"
                                            ? <div className="error-text"><br />{this.state.isDialogLoading}</div>
                                            : null
                                }
                            &nbsp;
                            <div className="action-panel-dialog">
                                    <span className="spring" />
                                    <button type="button" className="button green" onClick={this.submitTextDialog} disabled={!this.state.messageType}>Send Text</button>
                                    <button type="button" className="button" onClick={this.closeTextDialog}>Close</button>
                                </div>
                            </section>
                        </form>
                    </ReactModal>
                    : null}

                <QuestionnaireViewInner
                    survey={this.state.survey}
                    displayContactInfo={true}
                    userDisplayName={this.props.authContext.user.displayName}
                    submitContactNote={this.handleContactNote}
                    canViewMessages={this.props.authContext.hasRight("msg:read")}
                />
                &nbsp;
                <div className="action-panel">
                    <span className="spring" />
                    {this.state.survey?.contactAllowed && this.state.canUseMessaging ? <button type="button" className="button text-with-icon push-right" onClick={this.openTextDialog} disabled={!this.state.survey.phone}><i className="icon-mobile" /><span>Re-Send Text</span></button> : null}
                    <button type="button" className="button text-with-icon" onClick={this.openContactDialog}><i className="icon-phone" /><span>Contacted</span></button>
                    {this.state.survey?.source === 3
                        ? this.props.authContext.isInGroup(WellKnownGroups.BetaOutreach)
                            ? <button type="button" className="button text-with-icon red" onClick={this.openNotNeededDialog}><i className="icon-times" /><span>Not Needed Until...</span></button>
                            : <button type="button" className="button text-with-icon red" onClick={this.openNotNeededDialog}><i className="icon-times" /><span>Wasn't Needed</span></button>
                        : null}
                    <Link to={{ pathname: "/appointments/create", state: { survey: this.state.survey } }} className="button green text-with-icon"><i className="icon-plus" /><span>New Appointment</span></Link>
                    {this.state.survey.hasAppointments
                        ? <HasRight right="appt:read"><Link className="button text-with-icon" to={{ pathname: `${this.props.location.pathname}/appointments` }}> <i className="icon-calendar" /><span>View Appointment(s)</span></Link></HasRight>
                        : null}
                </div>
            </div>
        );
    }

    private renderNotNeededDialog() {
        const contactDate = parseDateSafe(this.state.contactStartDate);
        const inPast = contactDate && contactDate <= DateTime.local();

        return <ReactModal isOpen={this.state.isNotNeededDialogOpen} onRequestClose={this.closeNotNeededDialog}
            overlayClassName="modal-overlay" className="modal-content modal-content-400" portalClassName="modal-portal"
            bodyOpenClassName="modal-open" contentLabel="Not needed dialog">
            <form className="input-form">
                <section className="info-block">
                    <header>
                        <h3>Not needed until...</h3>
                    </header>
                    <section>
                        <div className="input-form-group">
                            <label>Note {!this.props.authContext.hasRight("oreach:c:note:opt") ? <small>(required)</small> : <small>(optional)</small>}</label>
                            <NoteBox ref={this.contactNoteRef} defaultNoteOpen={true} allowUpload={true} requireUpload={false} uploadCompress="image" hideLoading={true} stayOpenAfterSubmit={true} mode="single" onNewNote={this.handleContactNoteDialog} onNewNoteChange={this.handleContactNoteChange} />
                        </div>
                    </section>
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="contact-start-date">Show back up after</label>
                            <input type="date" id="contact-start-date" name="contactStartDate" value={this.state.contactStartDate} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                    {contactDate && contactDate.diffNow("months")?.months > 18
                        ? <>&nbsp;<div className="warning-box">The specified date is <b>{Math.floor(contactDate.diffNow("months").months).toFixed(0)}</b> months from now. Please make sure this is correct.</div></>
                        : contactDate && contactDate <= DateTime.local()
                            ? <>&nbsp;<div className="error-box">The specified date is in the past! You must choose a future date.</div></>
                            : null}
                    {
                        this.state.isDialogLoading === true
                            ? <div className="spinner lds-dual-ring" />
                            : typeof this.state.isDialogLoading === "string"
                                ? <div className="error-text"><br />{this.state.isDialogLoading}</div>
                                : null
                    }
                            &nbsp;
                            <div className="action-panel-dialog">
                        <span className="spring" />
                        <button type="button" className="button green" onClick={this.submitContactDialog} disabled={this.isContactDialogButtonDisabled() || inPast}>Submit</button>
                        <button type="button" className="button" onClick={this.closeNotNeededDialog}>Close</button>
                    </div>
                </section>
            </form>
        </ReactModal>;
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLTextAreaElement>, callback?: () => void) {
        const name = e.currentTarget.name;
        const value: string | boolean | any = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any, (callback && typeof callback === "function") ? callback : undefined);
    }

    private handleTextMessageType = (e: ChangeEvent<HTMLSelectElement>) => this.handleInputChanged(e, this.loadRenderedTemplate);


    private async loadSurvey() {
        try {
            this.setState({
                isLoading: true
            });

            const survey = await V2.get<any>(`survey/${this.props.match.params.id}?questions=full_contact`);

            this.setState({
                isLoading: false,

                survey
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e.error || "Could not load survey"
            });
        }
    }

    private async handleContactNote(body: string, files?: string[]) {
        const data = {
            body,
            files
        };

        const noteResult = await V2.post<any>(`survey/${this.state.survey.id}/notes/contact/${this.props.group}`, data);
        noteResult.author = formatName(noteResult.employee.name);

        const survey = this.state.survey;
        const notes = survey.contactNotes;
        notes.push(noteResult);

        this.setState({
            survey
        });
    }

    private async handleContactNoteDialog(body: string, files?: string[]) {
        // The dialog doesn't need to submit the note to the regular endpoint, the contacted endpoint handles it
        this.setState({
            contactNote: body,
            contactFiles: files || []
        });
    }

    private handleContactNoteChange(body: string) {
        this.setState({
            contactNote: body
        });
    }

    private handleNotNeeded() {
        this.setState({
            contactStatus: "notneeded"
        }, () => this.submitContactDialog());
    }

    private openContactDialog() {
        this.setState({
            isContactDialogOpen: true
        });
    }

    private closeContactDialog() {
        this.setState({
            isContactDialogOpen: false,
            isDialogLoading: false,

            contactStatus: "",
            contactStartDate: "",
            contactStartTime: "",
            contactEndDate: "",
            contactEndTime: "",
        });
    }

    private renderContactDialogInnerBody() {
        switch (this.state.contactStatus) {
            case "reachedmakeappointment":
                return <section>
                    <span>You will be sent to the appointment creation page after submission.</span>
                </section>;
            case "calllater":
                return <>
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="contact-start-date">Range Start Date</label>
                            <input type="date" id="contact-start-date" name="contactStartDate" value={this.state.contactStartDate} onChange={this.handleInputChanged} />
                        </div>
                        <div className="input-form-group">
                            <label htmlFor="contact-start-time">Range Start Time</label>
                            <input type="time" id="contact-start-time" name="contactStartTime" value={this.state.contactStartTime} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="contact-end-date">Range End Date</label>
                            <input type="date" id="contact-end-date" name="contactEndDate" value={this.state.contactEndDate} onChange={this.handleInputChanged} />
                        </div>
                        <div className="input-form-group">
                            <label htmlFor="contact-end-time">Range End Time</label>
                            <input type="time" id="contact-end-time" name="contactEndTime" value={this.state.contactEndTime} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                </>;
            default:
                return null;
        }
    }

    private isContactDialogButtonDisabled() {
        let base = !this.props.authContext.hasRight("oreach:c:note:opt") && !this.state.contactNote?.trim();
        switch (this.state.contactStatus) {
            case "calllater": return base || !this.state.contactStartDate || !this.state.contactStartTime;
            case "notneeded": return base || !this.state.contactStartDate;
            default: return base || !this.state.contactStatus;
        }
    }

    private async submitContactDialog() {
        try {
            this.setState({
                isDialogLoading: true
            });

            const data: any = {
                status: this.state.contactStatus
            };

            if (this.state.contactFiles.length === 0) {
                // Process note and upload files
                if (await this.contactNoteRef.current?.submit() === false) {
                    this.setState({
                        isDialogLoading: false,
                    });
                    return;
                }
            }

            if (this.state.contactNote) {
                data.note = this.state.contactNote;
                data.attachments = this.state.contactFiles;
            }

            if (this.state.contactStatus === "calllater") {
                data.callbackStart = `${this.state.contactStartDate}T${this.state.contactStartTime}`;
                data.callbackEnd = this.state.contactEndDate && this.state.contactEndTime
                    ? `${this.state.contactEndDate}T${this.state.contactEndTime}`
                    : undefined;
            }
            else if (this.state.contactStatus === "notneeded" && this.state.contactStartDate) {
                data.callbackStart = `${this.state.contactStartDate}T00:00:00Z`;
            }

            await V2.put<any>(`survey/outreach/group/${this.props.group}/${this.state.survey.id}/contact`, data);

            this.setState({
                isDialogLoading: false,
            });

            switch (data.status) {
                case "reachedmakeappointment":
                    // Send to appointment creation
                    this.closeContactDialog();
                    this.props.history.replace("/appointments/create", { survey: this.state.survey, allowNoProof: true });
                    break;
                default:
                    this.props.history.goBack();
                    break;
            }
        }
        catch (e) {
            this.setState({
                isDialogLoading: e.message || e.error || "Could not save contact status"
            });
        }
    }

    private openNotNeededDialog() {
        this.setState({
            isNotNeededDialogOpen: true,
            contactStatus: "notneeded"
        });
    }

    private closeNotNeededDialog() {
        this.setState({
            isNotNeededDialogOpen: false,
            isDialogLoading: false,

            contactStatus: "",
            contactStartDate: "",
            contactEndDate: "",
        });
    }

    private toggleEditDialog() {
        const isEditDialogDialogOpen = this.state.isEditDialogDialogOpen;

        if (!isEditDialogDialogOpen) {
            // Load information
            this.setState({
                editNameFirst: this.state.survey.name.first,
                editNameLast: this.state.survey.name.last,
                editBirthdate: this.state.survey.birthdate?.substring(0, 10) || "",
                editPhone: this.state.survey.phone,
                editInsurance: this.state.survey.insurance.provider,
            });
        }

        this.setState({
            isEditDialogDialogOpen: !isEditDialogDialogOpen
        });
    }

    private async submitEditDialog() {
        try {
            this.setState({
                isDialogLoading: true
            });

            const {
                editNameFirst,
                editNameLast,
                editBirthdate,
                editPhone,
                editInsurance,
                survey,
            } = this.state;

            const data: any = {};

            if (editNameFirst !== survey.name.first || editNameLast !== survey.name.last) {
                data.name = {
                    first: editNameFirst,
                    last: editNameLast
                };
            }
            if (editBirthdate !== survey.birthdate) {
                data.birthdate = editBirthdate;
            }
            if (editPhone !== survey.name.phone) {
                data.phone = editPhone.replace(/[^\d]/g, "");
            }
            if (editInsurance !== survey.insurance?.provider) {
                data.insurance = {
                    provider: editInsurance
                };
            }

            await V1.patch<void>(`survey/${this.state.survey.id}`, data);

            // Update visible survey info so we don't have to reload it
            survey.name.first = editNameFirst;
            survey.name.last = editNameLast;
            survey.birthdate = editBirthdate;
            survey.phone = editPhone;
            survey.insurance.provider = editInsurance;

            this.setState({
                isDialogLoading: false,
                isEditDialogDialogOpen: false,

                survey
            });
        }
        catch (e) {
            this.setState({
                isDialogLoading: e.message || "Could not save changes"
            });
        }
    }

    private async loadMessagingInfo() {
        try {
            let templateType;
            switch (this.props.group) {
                case WellKnownGroups.AppointmentSpecialist: templateType = "ahs"; break;
                case WellKnownGroups.SurgicalConsultant: templateType = "surgconsult"; break;
                case WellKnownGroups.PatientCareRep: templateType = "pcr"; break;
                default: templateType = ""; break;
            }

            if (!templateType) {
                // No known template type, treat it the same as not having messaging access
                this.setState({
                    canUseMessaging: false,
                });

                return;
            }

            var [results, templates] = await Promise.all([
                V2.get<any>("messaging/numbers/own"),
                V2.get<any>("messaging/templates?type=ahs"),
            ]);

            if (results.defaultNumber) {
                this.setState({
                    messagingNumber: results.defaultNumber
                });
            }
            else {
                // No number, treat it the same as not having messaging access
                this.setState({
                    canUseMessaging: false,
                    messagingNumber: {},
                });

                return;
            }

            this.setState({
                messageTemplates: templates.templates
            });
        }
        catch (e) {
            // Something went wrong
            this.setState({
                canUseMessaging: false,
                messagingNumber: {},
            });
        }
    }

    private openTextDialog() {
        const templates = this.state.messageTemplates;

        this.setState({
            isTextDialogOpen: true,
            messageType: templates.length === 1 ? templates[0].id : ""
        }, () => {
            if (this.state.messageType) {
                this.loadRenderedTemplate();
            }
        });
    }

    private closeTextDialog() {
        this.setState({
            isTextDialogOpen: false,
            isDialogLoading: false,
        });
    }

    private async submitTextDialog() {
        try {
            this.setState({
                isDialogLoading: true
            });

            const data = {
                templateId: this.state.messageType === "custom"
                    ? undefined
                    : this.state.messageType,
                numberId: this.state.messagingNumber.id,
                messageBody: this.state.messageBody !== this.state.messageBodyOriginal || this.state.messageType === "custom"
                    ? this.state.messageBody
                    : undefined,
            };

            await V2.post<void>(`survey/outreach/group/${this.props.group}/${this.state.survey.id}/send-text`, data);

            this.setState({
                isDialogLoading: false
            });

            this.closeTextDialog();
            this.loadSurvey();
        }
        catch (e) {
            this.setState({
                isDialogLoading: e.message || e.error || "Could not save contact status"
            });
        }
    }

    private async loadRenderedTemplate() {
        if (!this.state.survey?.id) {
            return;
        }

        if (!this.state.messageType || this.state.messageType === "custom") {
            this.setState({
                messageBody: "",
                messageBodyOriginal: "",
            });

            return;
        }

        try {
            this.setState({
                isDialogLoading: true,
                messageBody: "",
                messageBodyOriginal: "",
            });

            const result = await V2.get<any>(`survey/outreach/group/${this.props.group}/render-template?template=${this.state.messageType}&survey=${this.state.survey?.id}`);

            this.setState({
                isDialogLoading: false,
                messageBody: result.result,
                messageBodyOriginal: result.result,
            });
        }
        catch (e) {
            this.setState({
                isDialogLoading: e.message || "Could not load message template"
            });
        }
    }

}

export const OutreachTelemarketerContactDetailsView = withTitle("Contact Details", withAuth(withProps(OutreachContactDetailsView, { group: WellKnownGroups.PatientCareRep })));
export const OutreachSurgicalConsultantContactDetailsView = withTitle("Contact Details", withAuth(withProps(OutreachContactDetailsView, { group: WellKnownGroups.SurgicalConsultant })));
export const OutreachAppointmentSpecialistContactDetailsView = withTitle("Contact Details", withAuth(withProps(OutreachContactDetailsView, { group: WellKnownGroups.AppointmentSpecialist })));
